import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { RequestRecogniseSubject } from '../shared/request-recognise-subject.model';

@Component({
  selector: 'app-endorse-detail-recognise',
  templateUrl: './endorse-detail-recognise.component.html',
  styleUrls: ['./endorse-detail-recognise.component.scss']
})
export class EndorseDetailRecogniseComponent implements OnInit, OnChanges {

  displayedColumns: string[] = ['materia', 'fecha',
  'semestre', 'evaluador'];
  dataSource: MatTableDataSource<RequestRecogniseSubject>;
  @Input() requets: RequestRecogniseSubject[];

  constructor() {
    this.setTable();
   }

   ngOnInit() {
    this.setTable();
  }
  ngOnChanges() {
    this.setTable();
  }
  private setTable() {
    this.dataSource = new MatTableDataSource(this.requets);
  }

}
